import { render } from "./CardProductA.vue?vue&type=template&id=a7a50f7a"
import script from "./CardProductA.vue?vue&type=script&lang=js"
export * from "./CardProductA.vue?vue&type=script&lang=js"

import "./CardProductA.vue?vue&type=style&index=0&id=a7a50f7a&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__